import React, { useState } from "react";
import Modal from "react-modal";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import "./index.css";
import { TfiLayoutGrid2Alt } from "react-icons/tfi";
import { RiCloseCircleFill } from "react-icons/ri";
import { useTranslation } from "../../../../../hooks/useTranslation";
Modal.setAppElement("#root");

const ImagesSlider = ({ images }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [sliderRef] = useKeenSlider({ loop: true });
  const fullImageUrls = images.map((img) =>
    img?.startsWith("http") ? img : `${img}`
  );

  return (
    <div className="relative">
      <div className="preview-image">
        <img
          src={fullImageUrls[0]}
          alt="Preview"
          className="w-full h-[441px] object-cover"
        />
      </div>

      <button
        onClick={() => setModalOpen(true)}
        className="px-[13px] py-[8px] rounded-[5px] bg-white text-[#4CAF50] text-base font-medium flex gap-[10px] items-center justify-center absolute bottom-[15px] right-[15px] z-10"
      >
        <TfiLayoutGrid2Alt size={18} /> {t("restaurantManagement").showall}
      </button>

      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="image-modal"
        overlayClassName="overlay"
      >
        <div ref={sliderRef} className="keen-slider">
          {fullImageUrls.map((img, i) => (
            <div key={i} className="keen-slider__slide">
              <img src={img} alt={`slide-${i}`} />
            </div>
          ))}
        </div>
        <button
          onClick={() => setModalOpen(false)}
          className="absolute top-[20px] right-[20px] z-10"
        >
          <RiCloseCircleFill size={30} className="text-white" />
        </button>
      </Modal>
    </div>
  );
};

export default ImagesSlider;
